import SchemaOrg from '@/components/feature/SchemaOrg';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import TrendingSection from './components/TrendingSection';
import CategoryShowcase from './components/CategoryShowcase';
import LatestUpdates from './components/LatestUpdates';
import ArticleHighlights from './components/ArticleHighlights';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <>
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg type="WebPage" data={{
        name: '星辰影院 - 免费电视剧在线观看',
        description: '星辰影院汇集免费电视剧全集，最新热播剧、国产剧高清在线观看，全程不缓冲流畅播放，追剧首选平台。',
        url: 'https://xingchencinema.com/',
      }} />
      <SEOHead
        title="星辰影院：免费电视剧 | 电视剧全集在线观看 - 最新热播剧国产剧高清不缓冲"
        description="星辰影院汇集免费电视剧全集，最新热播剧、国产剧高清在线观看，全程不缓冲流畅播放，追剧首选平台。每日更新最新电视剧资源，为您提供流畅高清的在线追剧体验。"
        keywords="星辰影院,免费电视剧,电视剧全集,最新电视剧,热播剧,国产剧,高清在线观看,不缓冲,星辰影院免费电视剧,星辰影院电视剧全集"
        canonicalUrl="/"
      />

      <main>
        <HeroSection />
        <TrendingSection />
        <CategoryShowcase />
        <LatestUpdates />
        <ArticleHighlights />
        <FAQSection />
        <NewsletterSection />
      </main>
    </>
  );
}